import EmailNotification from 'models/notification/email/EmailNotification';

/**
 * Class representing a reset password email notification.
 * @extends EmailNotification
 */
export default class ResetPassEmailNotification extends EmailNotification {
	_type = 'reset-pass';
}
